import React, { useState } from "react";
import QurealCanvasWrapper from "./QurealCanvasWrapper";
import LinkedPostView from "../../linkedin_posts/LinkedinPostView";
import { Button, message, Select, Popconfirm } from "antd";
import axios from "axios";
import CanvasFeedbackBar from "./CanvasFeedbackBar";
import { useMedia } from "react-use";
import { startCase } from "lodash";
import { useSchedulePost } from "../../_actions/bot";
import { socialAccountAtom } from "../../social_media/SocialPostButton";
import SocialPostButton from "../../social_media/SocialPostButton";
import SocialPostingBox from "../../social_media/SocialPostingBox";
import { useSetAtom, useAtom } from "jotai";
import { MenuOutlined, DeleteOutlined } from "@ant-design/icons";
import { useDeleteItemMutation } from "../../_actions/app/items";
import { queryClient } from "../../_helpers/query";

function QurealLinkedInPreview({
    me,
    data,
    closeBtn,
    close_left = false,
    history_id,
    open_cust = true,
    setOpenCust,
    entry_id,
    platforms = [],
    close = () => { },
}) {
    // console.log("check first ", open_cust);
    // console.log("      MAHIIIII", platforms);
    // console.log("entry id      MAHIIIII", entry_id);
    // console.log("MAHIIMMMMMMMMMMMMMMMMIII", me?.selected_org?.id);
    //   console.log("Hfgdfsasdbfj      MAHIIIII", platforms);
    const isMobile = useMedia("(max-width: 700px)");
    const [posting, setPosting] = useState(false);
    const [approvalValue, setApprovalValue] = useState(null);
    const user_id = me?.id;
    const org_id = me?.selected_org?.id;
    const [socialAccount] = useAtom(socialAccountAtom);
    const mutationSchedulePost = useSchedulePost((result) => {
        // log.d(result, "schedule Post Result");
        if (
            result?.data?.success === false &&
            result?.data?.error?.code === "TOKEN_INSUFFICIENT"
        ) {
            message.error(result?.data?.error?.msg);
            // setOpenTokenModal(true);
        }
        // refetchItem();
    });

    const deleteMutation = useDeleteItemMutation(() => {
        message.success("Entry deleted successfully!");
        queryClient.invalidateQueries(["items", "qdb_calendar_entries"]);
        if (close) close();
    });

    const handleCopy = () => {
        navigator.clipboard
            .writeText(data.content)
            .then(() => {
                console.log("Data copied to clipboard");
                message.success("Data copied to clipboard");
            })
            .catch((err) => {
                console.error("Failed to copy data: ", err);
                message.error("Failed to copy");
            });
    };

    const handlePost = async () => {
        if (!user_id || !org_id) {
            message.error("Missing required user or organization information");
            return;
        }

        setPosting(true);
        try {
            const response = await axios.post(
                "http://localhost:8000/social/linkedin/post",
                {
                    user_id: user_id,
                    post_content: data.content,
                    org_id: org_id,
                }
            );

            console.log("Post response:", response);
            message.success("Successfully posted to LinkedIn");
        } catch (error) {
            console.error("Failed to post:", error);
            message.error("Failed to post to LinkedIn");
        } finally {
            setPosting(false);
        }
    };

    return (
        <QurealCanvasWrapper
            title="LinkedIn Preview"
            actions_left={[
                !isMobile && (
                    <Button
                        icon={<MenuOutlined />}
                        onClick={() => {
                            // console.log("check second ", open_cust);

                            setOpenCust(!open_cust);
                            // console.log(open_cust ? "Close" : "Open");
                            // console.log("check second ", open_cust);
                        }}
                    ></Button>
                ),
            ]}
            actions={[
                isMobile && (
                    <CanvasFeedbackBar
                        history_id={history_id}
                        entry_id={entry_id}
                        inline={true}
                    />
                ),

                // <Select
                //     style={{ width: 120 }}
                //     options={["approve", "reject", "pass"].map((item) => ({
                //         value: item,
                //         label: startCase(item),
                //     }))}
                //     value={approvalValue}
                //     onChange={(val) => setApprovalValue(val)}
                //     allowClear
                //     placeholder="Action"
                // />,

                // <Button
                //     size="small"
                //     loading={mutationSchedulePost.isLoading}
                //     onClick={() => {
                //         if (!approvalValue) {
                //             message.error("Please select an action");
                //             return;
                //         }

                //         if (!entry_id) {
                //             message.error("Missing entry id");
                //             return;
                //         }
                //         const statusMap = {
                //             approve: "approved",
                //             reject: "rejected",
                //             pass: "passed",
                //         };
                //         const post_status =
                //             statusMap[approvalValue] || approvalValue;
                //         mutationSchedulePost.mutate({
                //             id: entry_id,
                //             post_status,
                //             output_format: "jpeg",
                //             social_account_id: socialAccount.id,
                //         });
                //     }}
                // >
                //     Go
                // </Button>,
                <Button onClick={handleCopy}>Copy</Button>,
                // <Button type="primary" onClick={handlePost} loading={posting}>
                //     Post
                // </Button>,
                // <SocialPostButton
                //     // template_id="adc24a8b-0afe-45c5-a11a-b963385225f3"
                //     // template_id={item?.id}
                //     org_id={me?.selected_org?.id}
                //     // // init_account_id={account_id}
                //     // prefill={prefill_data}
                //     to="linkedin"
                // />,
                close_left && closeBtn,
            ]}
            header_height={50}
            controlPanel={
                <div style={{ padding: "15px", height: "100%", overflowY: "auto", display: "flex", flexDirection: "column" }}>
                    <div style={{ flex: 1 }}>
                        <SocialPostingBox
                            platforms={platforms}
                            entry_id={entry_id}
                            org_id={me?.selected_org?.id}
                        />
                    </div>
                    {entry_id ? <div style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "flex-end",
                        paddingTop: "20px"
                    }}

                    >
                        <Popconfirm
                            title="Delete entry"
                            description="Are you sure you want to delete this entry?"
                            onConfirm={() => {
                                deleteMutation.mutate({
                                    collection: "qdb_calendar_entries",
                                    id: entry_id,
                                });
                            }}
                            okText="Yes"
                            cancelText="No"
                            okButtonProps={{ danger: true }}
                        >
                            <Button danger icon={<DeleteOutlined />} loading={deleteMutation.isLoading}>Delete</Button>
                        </Popconfirm>
                    </div> : null}
                </div>
            }
            open_cp={open_cust}
            setOpenCp={setOpenCust}
        >
            <LinkedPostView content={data} />
            {!isMobile && (
                <CanvasFeedbackBar
                    history_id={history_id}
                    entry_id={entry_id}
                />
            )}
        </QurealCanvasWrapper>
    );
}

export default QurealLinkedInPreview;
